module.exports = __webpack_public_path__ + "static/media/project_8.faed540a.png";